import React from 'react'
import { useStore } from '../../lib/context'
import { observer } from 'mobx-react-lite'

const MobileLogo = observer(() => {
	const {
		uiStore: { navBar__textColor, directory__mobileMenuOpen },
	} = useStore()

	return (
		<>
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160 117.28">
				<g>
					<g>
						<path d="M122.9,84.42a33.05,33.05,0,0,1-4.82,15.26,37.45,37.45,0,0,1-20.64,15.59,45.85,45.85,0,0,1-13.67,2H5.17A5.16,5.16,0,0,1,0,112.12V5.17A5.16,5.16,0,0,1,5.17,0h74.3c8.85,0,18,1.93,25.24,7.3,7,5.24,11.28,13.6,12.85,21.72a33.4,33.4,0,0,1-6.26,26.46c-.87,1.19,1.4,2.68,2.09,3.38a30.78,30.78,0,0,1,7,9.9A35,35,0,0,1,122.9,84.42Z" />

						<path d="M140.45,3.35a.9.9,0,0,1,.25-.17l-1.54-.08V0h6.47V3.24h-.3a3.23,3.23,0,0,0-2.36.93,4.91,4.91,0,0,0-1.2,3.54,4.26,4.26,0,0,0,1,3.07,2.85,2.85,0,0,0,2,.74,2.37,2.37,0,0,0,1.81-.72A6.56,6.56,0,0,0,148,7.54l.44-1.92a8.29,8.29,0,0,1,2-4.06,5.08,5.08,0,0,1,3.7-1.31,5.71,5.71,0,0,1,4.09,1.61A6.52,6.52,0,0,1,160,6.55a5.71,5.71,0,0,1-1.62,4.25.4.4,0,0,1-.19.17l1.54.08v3h-6.2V10.83h.38A2.82,2.82,0,0,0,156,10a4,4,0,0,0,1-2.88,3.46,3.46,0,0,0-.9-2.5,2.72,2.72,0,0,0-2-.76,2.13,2.13,0,0,0-1.59.63,5.44,5.44,0,0,0-1.2,2.74L151,9a9,9,0,0,1-2.17,4.64A5.11,5.11,0,0,1,145,15.08a5.83,5.83,0,0,1-4.3-1.7,7.25,7.25,0,0,1-1.95-5.24A6.58,6.58,0,0,1,140.45,3.35Z" />
						<path d="M142,16.92V18A.87.87,0,0,0,143,19h12.94a.87.87,0,0,0,.94-.94V16.92h2.88V32.06h-6.28V28.93h2.46a.88.88,0,0,0,.94-1V22.18h-5.38v5.19h-2.93V22.18H142v6.2a.88.88,0,0,0,.93,1h2.85v3.13h-6.66V16.92Z" />
						<path d="M142,34.66v.63a1.24,1.24,0,0,0,.85,1.24l14,5.21V39.21h2.88v7.41L142.89,52.9a1.24,1.24,0,0,0-.85,1.23v.63h-2.88V47H142v1c0,.94.58,1.4,1.51,1.07l2-.65V41l-2-.66c-.93-.33-1.51.14-1.51,1.1v1h-2.88V34.66Zm6.36,12.73,8.12-2.72L148.4,42Z" />
						<path d="M140.45,60.19a.9.9,0,0,1,.25-.16L139.16,60v-3.1h6.47v3.23h-.3A3.24,3.24,0,0,0,143,61a4.88,4.88,0,0,0-1.2,3.53,4.27,4.27,0,0,0,1,3.08,2.85,2.85,0,0,0,2,.74,2.37,2.37,0,0,0,1.81-.72A6.61,6.61,0,0,0,148,64.39l.44-1.92a8.29,8.29,0,0,1,2-4.06,5.08,5.08,0,0,1,3.7-1.31,5.71,5.71,0,0,1,4.09,1.61A6.52,6.52,0,0,1,160,63.4a5.71,5.71,0,0,1-1.62,4.25.4.4,0,0,1-.19.17l1.54.08v3h-6.2V67.68h.38a2.82,2.82,0,0,0,2.09-.82A4,4,0,0,0,157,64a3.46,3.46,0,0,0-.9-2.5,2.72,2.72,0,0,0-2-.76,2.13,2.13,0,0,0-1.59.63,5.4,5.4,0,0,0-1.2,2.74L151,65.87a8.94,8.94,0,0,1-2.17,4.63A5.07,5.07,0,0,1,145,71.93a5.83,5.83,0,0,1-4.3-1.7A7.25,7.25,0,0,1,138.72,65,6.62,6.62,0,0,1,140.45,60.19Z" />
						<path d="M149.36,73.66a10.54,10.54,0,1,1-10.64,10.53A10.37,10.37,0,0,1,149.36,73.66Zm0,17.68c4.31,0,7.51-3,7.51-7.15s-3.2-7.13-7.51-7.13-7.49,3-7.49,7.13A7.16,7.16,0,0,0,149.36,91.34Z" />
						<path d="M142,96.09v1.12a.86.86,0,0,0,.93.93h12.94a.86.86,0,0,0,.94-.93V96.09h2.88v4.71l-14.56,11.36h10.74a.87.87,0,0,0,.94-.94V109h2.88v8.33h-2.88v-.85a.87.87,0,0,0-.94-.93H139.16v-2.58l14.73-11.46H143a.88.88,0,0,0-.93,1v2.28h-2.88V96.09Z" />
					</g>
				</g>
			</svg>
			<style jsx>{`
				svg {
					display: none;
					height: 50px;
				}
				path,
				rect {
					transition-duration: 0.6s;

					fill: ${directory__mobileMenuOpen ? 'black' : navBar__textColor};
				}

				@media only screen and (max-width: 768px) {
					svg {
						display: block;
					}
				}
			`}</style>
		</>
	)
})

export default MobileLogo
